<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="adc">
<p class="center"><span class="small">NONFICTION TITLES BY CAROLLY ERICKSON</span></p>
<p class="center"><em>The Records of Medieval Europe<br/>The Medieval Vision<br/>Civilization and Society in the West<br/>Bloody Mary<br/>Great Harry<br/>The First Elizabeth<br/>Mistress Anne<br/>Our Tempestuous Day<br/>Bonnie Prince Charlie<br/>To the Scaffold<br/>Great Catherine<br/>Her Little Majesty<br/>Arc of the Arrow<br/>Josephine<br/>Alexandra<br/>Royal Panoply<br/>Lilibet<br/>The Girl from Botany Bay</em></p>
<p class="center"><span class="small">FICTION</span><br/><em>The Hidden Diary of Marie Antoinette</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312316433_epub_adc_r1.vue?d3daec00